import { BaseContainerModel } from '../../base-container.model';
import { Bl_inv_stock_take_session_report_line_RowClass } from '../../../dbschema/bl_inv_stock_take_session_report_line.model';

export class StockTakeSessionReportLineModel extends BaseContainerModel {
  bl_inv_stock_take_session_report_line: Bl_inv_stock_take_session_report_line_RowClass = new Bl_inv_stock_take_session_report_line_RowClass();
}
